
Core.CheckoutComment = function(elem, btnCheck) {
    var BTN_SHOW_TEXT_ADD = 'Add Product Comment';
    var BTN_SHOW_TEXT_EDIT = 'Edit Product Comment';
    var ERROR_TMPL = '<div data-comment="error" class="small text-red mx-0 mt-2 mb-0">Maximum 250 characters</div>';
    var COMMENT_FORM_ID = Date.now() + '-' + Math.floor(Math.random() * 100) + '-' + Math.floor(Math.random() * 100);

    function hide(elem) {
        elem && elem.classList.add('d-none');
    }

    function show(elem) {
        elem && elem.classList.remove('d-none');
    }

    function hasAllTheFields(fieldList) {
        var previousValue = true;

        fieldList.forEach(function(currentValue) {
            previousValue = previousValue && currentValue;
        });

        return previousValue;
    }


    var el = {
        elem: elem,

        btnShow: elem.querySelector('[data-comment="btn-show"]'),

        inputHidden: elem.querySelector('[data-comment="hidden"]'),
        commentText: elem.querySelector('[data-comment="text"]'),
        form: elem.querySelector('[data-comment="form"]'),
        textarea: elem.querySelector('[data-comment="textarea"]'),

        btnSave: elem.querySelector('[data-comment="save"]'),
        btnCancel: elem.querySelector('[data-comment="cancel"]'),
        btnDelete: elem.querySelector('[data-comment="delete"]'),
    };

    var data = {
        isValid: true
    };

    // Methods
    var m = {
        init: function() {
            var fieldList = [
                el.btnShow,
                el.inputHidden,
                el.commentText,
                el.textarea,
                el.form,
                el.btnSave,
                el.btnCancel,
                el.btnDelete
            ];

            if (! hasAllTheFields(fieldList)) {
                return;
            }

            m.boot();
        },


        boot: function() {
            el.btnShow.addEventListener('click', m.showForm);
            el.btnCancel.addEventListener('click', m.onClickCancel);
            el.btnDelete.addEventListener('click', m.onClickDelete);
            el.btnSave.addEventListener('click', m.onClickSave);
            el.textarea.addEventListener('input', function() {
                el.textarea.value.length > 250
                    ? m.showError()
                    : m.hideError();
            });
        },

        showForm: function(e) {
            e.preventDefault();

            m.setTextArea(el.inputHidden.value);
            show(el.form);
            hide(el.commentText);
            hide(el.btnShow);
            btnCheck.openCommentForm(COMMENT_FORM_ID);
        },

        onClickCancel: function(e) {
            e.preventDefault();

            hide(el.form);
            show(el.btnShow);
            show(el.commentText);
            m.setTextArea('');
            m.hideError();
            btnCheck.closeCommentForm(COMMENT_FORM_ID);
        },

        onClickDelete: function(e) {
            e.preventDefault();

            m.setBtnShowText(BTN_SHOW_TEXT_ADD);
            m.setTextArea('');
            m.setInputHidden('');
            m.setCommentText('');
            m.hideError();

            hide(el.form);
            show(el.commentText);
            show(el.btnShow);

            btnCheck.closeCommentForm(COMMENT_FORM_ID);
        },

        onClickSave: function(e) {
            e.preventDefault();

            if (! data.isValid) {
                return;
            }

            m.setInputHidden(el.textarea.value);
            m.setCommentText(el.textarea.value)
            el.textarea.value.length > 0
                ? m.setBtnShowText(BTN_SHOW_TEXT_EDIT)
                : m.setBtnShowText(BTN_SHOW_TEXT_ADD);
            hide(el.form);
            show(el.btnShow);
            show(el.commentText);
            m.setTextArea('');

            btnCheck.closeCommentForm(COMMENT_FORM_ID);
        },

        setTextArea: function(val) {
            el.textarea.value = val;
        },

        setInputHidden: function(val) {
            el.inputHidden.value = val;
        },

        setCommentText: function(val) {
            el.commentText.innerText = val;
        },

        setBtnShowText: function(text) {
            el.btnShow.innerText = text;
        },

        showError: function() {
            if (!data.isValid) {
                return;
            }

            data.isValid = false;
            $(el.textarea).after(ERROR_TMPL);
            el.btnSave.disabled = true;
        },

        hideError: function() {
            if (data.isValid) {
                return;
            }

            data.isValid = true;
            $(elem).find('[data-comment="error"]').remove();
            el.btnSave.disabled = false;
        },

    };

    return m;
};
